import * as React from "react"

const CreateAccountForm = () => {
  const [email, setEmail] = React.useState("")
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ event: "submit-start-free-form" })
        setTimeout(
          () =>
            window.open(
              "https://app.teamspective.com/register?email=" + email,
              "_blank"
            ),
          200
        )
      }}
    >
      <input
        type="email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        placeholder="Enter your work email"
      />
      <button className="button button-primary action-start-free" type="submit">
        Sign up
      </button>
      <p className="disclaimer">*No Credit Card Required</p>
    </form>
  )
}

export default CreateAccountForm
